<template>
    <l-modal size="m" :close-on-backdrop-click="false" @close="close">
        <template #header> {{ keyResult.name }} </template>
        <template #body>
            <div>
                <div v-if="keyResult.description">
                    {{ keyResult.description }}
                    <div class="hr-small" />
                </div>

                <!-- Comment Input -->
                <div class="tw-font-bold">{{ $t("goals.updateKRModal.why") }}</div>

                <div class="hr-small" />

                <l-rich-text-editor
                    v-model="newComment"
                    :allow-mention="true"
                    :content="newComment"
                ></l-rich-text-editor>
                <!--/Comment Input -->

                <l-space :size="1" />

                <div
                    v-if="
                        keyResult.canUpdateStatus ||
                            (keyResult.toDiscuss && keyResult.toDiscuss !== 'zero')
                    "
                >
                    <div class="tw-font-bold tw-flex">
                        <span class="tw-flex-1">{{ $t("goals.updateKRModal.status") }}</span>
                        <span
                            v-show="
                                keyResult.canUpdateStatus &&
                                    keyResult.toDiscuss &&
                                    keyResult.toDiscuss !== 'zero'
                            "
                            class="tw-text-gray-400 tw-font-normal tw-my-0 tw-py-0 tw-cursor-pointer"
                            @click="setStatus('zero')"
                            @keyup.enter="setStatus('zero')"
                        >
                            <i class="fal fa-trash tw-mr-2"></i> {{ $t("goals.update.labelZero") }}
                        </span>
                    </div>

                    <div class="hr-small" />

                    <div class="tw-flex">
                        <button
                            class="tw-flex-1 btn btn-sm btn-success"
                            :class="{ 'btn-raised': keyResult.toDiscuss == 'canceled' }"
                            @click="setStatus('canceled')"
                        >
                            <span>{{ $t("goals.update.labelCanceled") }}</span>
                        </button>
                        <button
                            class="tw-flex-1 btn btn-sm btn-success"
                            :class="{ 'btn-raised': keyResult.toDiscuss == 'offTrack' }"
                            @click="setStatus('offTrack')"
                        >
                            <span>{{ $t("goals.update.labelOffTrack") }}</span>
                        </button>
                        <button
                            class="tw-flex-1 btn btn-sm btn-success"
                            :class="{ 'btn-raised': keyResult.toDiscuss == 'inputNeeded' }"
                            @click="setStatus('inputNeeded')"
                        >
                            <span>{{ $t("goals.update.labelInputNeeded") }}</span>
                        </button>
                        <button
                            class="tw-flex-1 btn btn-sm btn-success"
                            :class="{ 'btn-raised': keyResult.toDiscuss == 'onTrack' }"
                            @click="setStatus('onTrack')"
                        >
                            <span>{{ $t("goals.update.labelOnTrack") }}</span>
                        </button>
                        <button
                            class="tw-flex-1 btn btn-sm btn-success"
                            :class="{ 'btn-raised': keyResult.toDiscuss == 'done' }"
                            @click="setStatus('done')"
                        >
                            <span>{{ $t("goals.update.labelDone") }}</span>
                        </button>
                    </div>

                    <l-space :size="1" />
                </div>

                <div class="tw-font-bold">{{ $t("goals.updateKRModal.value") }}</div>

                <div class="hr-small" />

                <div class="row">
                    <div class="col-md-3">
                        <l-input-text
                            v-if="keyResult.metricType !== 'none'"
                            v-model="keyResult.metricCurrent"
                            type="number"
                            :label="``"
                            hide-help-block
                        />
                        <l-select
                            v-else
                            v-model="keyResult.metricCurrent"
                            :options="[
                                { value: '0', text: $t(`goals.update.optionIncomplete`) },
                                { value: '100', text: $t(`goals.update.optionComplete`) },
                            ]"
                        />
                    </div>
                    <div v-if="keyResult.metricType !== 'none'" class="col-md-6 tw-pt-1 tw-text-lg">
                        / {{ keyResult.metricEnd }}
                    </div>
                </div>

                <l-space :size="1" />

                <!-- Buttons -->
                <div class="row">
                    <div class="col-md-offset-6 col-md-3"></div>
                    <div class="col-md-3">
                        <button
                            class="pull-right btn btn-primary btn-block btn-raised"
                            @click="updateKR()"
                        >
                            {{ $t("goals.updateKRModal.submit") }}
                        </button>
                    </div>
                </div>
                <!--/Buttons -->
            </div>
            <div class="footer"></div>
        </template>
    </l-modal>
</template>

<script>
import LRichTextEditor from "@/components/LRichTextEditor";

import LInputText from "@/components/LInputText";
import LSelect from "@/components/LSelect";
import LModal from "@/components/LModal";
import LSpace from "@/components/LSpace";

export default {
    components: {
        LRichTextEditor,
        LModal,
        LSpace,
        LSelect,
        LInputText,
    },
    props: {
        goal: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            newComment: "",

            keyResult: {},
        };
    },
    computed: {
        keyResultId() {
            return this.$route.query?.editKeyResultId;
        },
    },
    watch: {
        goal: {
            immediate: true,
            handler(goal) {
                if (!goal) {
                    return;
                }
                this.keyResult = { ...goal.keyResults?.find(k => k._id === this.keyResultId) };
            },
        },
        keyResultId: {
            immediate: true,
            handler(key) {
                if (!key) {
                    return;
                }
                this.keyResult = { ...this.goal.keyResults?.find(k => k._id === key) };
            },
        },
    },
    methods: {
        close() {
            this.$router
                .replace({
                    query: {
                        ...this.$route.query,
                        editGoalId: undefined,
                        editKeyResultId: undefined,
                    },
                })
                .catch(() => {});
        },
        setStatus(status) {
            if (!this.keyResult.canUpdateStatus) {
                return;
            }

            if (this.keyResult.toDiscuss !== status) {
                this.$set(this.keyResult, "toDiscuss", status);
            } else {
                this.$set(this.keyResult, "toDiscuss", "zero");
            }
        },
        async updateKR() {
            //updateKR
            const goal = this.goal;
            if (!goal || goal.status === "archived" || !goal.keyResults) {
                return;
            }
            this.keyResult.progress = Math.round(
                ((this.keyResult.metricCurrent - this.keyResult.metricStart) /
                    (this.keyResult.metricEnd - this.keyResult.metricStart)) *
                    100,
            );

            const index = goal.keyResults.findIndex(kr => kr._id === this.keyResultId);
            goal.keyResults[index] = this.keyResult;

            await this.$store.dispatch({
                type: "goals/goals/update",
                payload: {
                    goal: {
                        ...goal,
                        scope: "partial",
                    },
                },
            });

            if (!this.newComment || this.newComment == "<p></p>") {
                this.close();
                this.$emit("update", { keyResult: this.keyResult, goal });
                return;
            }

            await this.$store.dispatch({
                type: "goals/comments/create",
                payload: {
                    commentContent: `${this.keyResult.name}: ${this.newComment}`,
                    goalId: goal._id,
                    keyResultId: this.keyResult._id,
                },
            });

            this.newComment = "";
            this.close();
            this.$emit("update", { keyResult: this.keyResult, goal });
        },
    },
};
</script>
